import React from 'react';
import { routeContext } from 'react-router5';
import config from 'config';
import { createWhatsAppLink } from 'utils/shareLinksUtils';
import { useLocale } from 'locale';
import { PoiId } from 'utils/entities';
import { isUnitPageRoute } from 'utils/marketplaceRoutes';
import { Route } from 'config/routes';

function useWhatsAppHref(whatsappNumber: string, agentName: string, poiId: PoiId) {
  const { router, route } = React.useContext(routeContext);
  const { t } = useLocale();

  const validPhoneNumber = Boolean(whatsappNumber);

  const whatsAppHref = React.useMemo(() => {
    if (isUnitPageRoute(route.name as Route)) {
      const url = `${config.oldILRoot}${router.buildPath(route.name, { id: poiId })}`;
      return createWhatsAppLink({ text: `${t('contactAgentModal.whatsapp.agent.message', { name: agentName ? ` ${agentName}` : '' })}\n${url}`, phone: whatsappNumber });
    }
    return null;
  }, [ agentName, validPhoneNumber, route.name, poiId ]);

  return whatsAppHref;
}

export default useWhatsAppHref;
